import HttpService from "./HttpService";

export const registerService = (formData) => {
	const http = new HttpService();
	const url = "users";

	return http.postData(formData, url);
};

export const verifyEmailService = (formData) => {
	const http = new HttpService();
	const url = `v2/users/email/verify`;

	return http.postData(formData, url);
}	

export const initRegistrationService = (formData) => {
	const http = new HttpService();
	const url = `v2/auth/register/init`;
	return http.postData(formData, url);
};

export const verifyBVNService = (formData) => {
	const http = new HttpService();
	const url = `v2/users/bvn/verify`;
	return http.postDataWithToken(formData, url);
};

export const resendEmailVerificationService = (formData) => {
	const http = new HttpService();
	const url = `v2/users/re-send/otp`;
	return http.postData(formData, url);
};

export const verifyBVNLast4Service = (formData) => {
	const http = new HttpService();
	const url = `v2/users/validate/bvn/phone`;
	return http.postDataWithToken(formData, url);
};

export const registerV2 = (formData) => {
	const http = new HttpService();
	const url = `v2/users`;
	return http.postDataWithToken(formData, url);
}


export const loginService = (formData) => {
	const http = new HttpService();
	const url = "login";

	return http.postData(formData, url);
};

export const resetPasswordService = (formData) => {
	const http = new HttpService();
	const url = `users/reset-password`;

	return http.postData(formData, url);
};

export const forgotPasswordService = (email) => {
	const http = new HttpService();
	const url = `users/${email}/forgot-password`;

	return http.postData(null, url);
};

export const logoutService = () => {
	const http = new HttpService();
	const url = "auth/logout";

	return http.postDataWithToken(null, url);
};

export const resendVerificationService = (email) => {
	const http = new HttpService();
	const url = `users/${email}/resend-email-verification-code`;

	return http.postData(null, url);
};